module.exports = __webpack_public_path__ + "media/assets/icons/chevron-right-7d462978a7512fed3e6e45c1dc2f9445.svg";